import React from 'react';
import { Helmet } from 'react-helmet';

import { PublicPageLayout } from 'src/common/components/public-page-layout/public-page-layout';
import { withProviders } from 'src/common/hocs/with-providers';

import { CustomerLogos } from './components/customer-logos/customer-logos';
import { Features } from './components/features/features';
import { Hero } from './components/hero/hero';
import { Testimonials } from './components/testimonials/testimonials';

const LandingComponent = () => (
  <PublicPageLayout hasSpecialOfferBanner>
    <Helmet>
      <link rel="canonical" href="https://streamable.com"></link>
    </Helmet>

    <Hero />

    <CustomerLogos />

    <Features />

    <Testimonials />
  </PublicPageLayout>
);

export const Landing = withProviders({
  isDarkModeSupported: false,
})(LandingComponent);
